import { gql } from '@apollo/client';
import { DONATION_FRAGMENT } from 'modules/donations/graphql/fragments';

export const GET_PREVIOUS_DONATION_QUERY = gql`
  query getPreviousDonation($input: GetPreviousDonationInput!) {
    getPreviousDonation(input: $input) {
      ...Donation
    }
  }
  ${DONATION_FRAGMENT}
`;

export const GET_DONATION_QUERY = gql`
  query getDonation($input: GetDonationInput!) {
    getDonation(input: $input) {
      ...Donation
    }
  }
  ${DONATION_FRAGMENT}
`;

export const GET_DONATION_LIST_QUERY = gql`
  query getDonationList($input: GetDonationsListInput!) {
    getDonationsList(input: $input) {
      data {
        ...Donation
      }
      meta {
        total
      }
    }
  }
  ${DONATION_FRAGMENT}
`;

export const GET_SPECIFIC_DONOR_DONATION_LIST_QUERY = gql`
  query getSpecificDonorDonationsList(
    $input: GetSpecificDonorDonationsListInput!
  ) {
    getSpecificDonorDonationsList(input: $input) {
      data {
        ...Donation
      }
      meta {
        total
      }
    }
  }
  ${DONATION_FRAGMENT}
`;

export const GET_DONATIONS_LIST_FOR_ANALYTICS_QUERY = gql`
  query getDonationsListForAnalytics($input: DonationsAnalyticsInput!) {
    getDonationsListForAnalytics(input: $input) {
      data {
        ...Donation
      }
      meta {
        total
      }
    }
  }
  ${DONATION_FRAGMENT}
`;

// Query to get phlebotomist stats for the Phlebotomist Dashboard
// NOTE: Canonical copy lives in dashboard/graphql/queries — keep in sync
export const GET_PHLEBOTOMIST_STATS_QUERY = gql`
  query getPhlebotomistStats($input: GetPhlebotomistStatsInput!) {
    getPhlebotomistStats(input: $input) {
      phlebotomistId
      phlebotomistName
      phlebotomistEmail
      regionId
      regionName
      locationPreference
      assignedOfficeId
      assignedOfficeName
      attemptedDonations
      successfulDonations
      pendingDonations
      singleDonors
      doubleDonors
      successfulSingleDonors
      successfulDoubleDonors
      expectedTotal
      expectedPRBC
      expectedPRBCSingle
      expectedPRBCDouble
      expectedFFPSingle
      expectedFFPDouble
      actualTotal
      actualPRBC
      actualPRBCSingle
      actualPRBCDouble
      actualFFPSingle
      actualFFPDouble
      dblDonorsSglYield
      overallSuccessRate
      prbcSuccessRate
      sglDonorsSuccessRate
      dblDonorsSuccessRate
      teamCount
      totalOfficeSuccessful
      donationSharePercent
      officeSharePercent
      completelyFailedDonations
      completelyFailedDiscards {
        reason
        count
      }
      partiallyFailedDonations
      partiallyFailedDiscards {
        reason
        count
      }
      recentDonations {
        id
        shortId
        date
        donorName
        donorId
        type
        approvedML
        actualML
        collectionSet
        veinSide
        donationUnit
        examinationNotes
        ineligibleReason
        expectedPRBC
        expectedFFPSingle
        expectedFFPDouble
        actualPRBC
        actualFFPSingle
        actualFFPDouble
        status
        phlebotomistName
        locationName
        regionName
        failureReasons
        products {
          type
          productId
          status
          orderId
          discardReason
        }
      }
    }
  }
`;

// Query to get phlebotomist trend stats for time-series charts
export const GET_PHLEBOTOMIST_TREND_STATS_QUERY = gql`
  query getPhlebotomistTrendStats($input: GetPhlebotomistTrendStatsInput!) {
    getPhlebotomistTrendStats(input: $input) {
      period
      periodStart
      periodEnd
      attemptedDonations
      successfulDonations
      singleDonors
      doubleDonors
      successfulSingleDonors
      successfulDoubleDonors
      expectedTotal
      expectedPRBC
      expectedFFPSingle
      expectedFFPDouble
      actualTotal
      actualPRBC
      actualFFPSingle
      actualFFPDouble
      overallSuccessRate
      prbcSuccessRate
      sglDonorsSuccessRate
      dblDonorsSuccessRate
    }
  }
`;
